module.exports = __webpack_public_path__ + "static/media/CSP1.3451f899.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/CSP1.png
// module id = 902
// module chunks = 0